/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getIrsInfo} from '../api'

 export const useQueryGetIrsInfo = createReactQueryHook('getIrsInfo', getIrsInfo)
